import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const TRANSIENT = '$$$transient';
export const TRANSIENT_FIELDS = '$$$transientFields';

export interface RHFFormsState {
  [formName: string]: Record<string, unknown>;
}

const initialState: RHFFormsState = {};

const rhfFormsSlice = createSlice({
  name: 'rhfForms',
  initialState,
  reducers: {
    setFormValues(
      state,
      action: PayloadAction<{ formName: string; values: Record<string, unknown> }>,
    ) {
      const isTransient = state[action.payload.formName]?.[TRANSIENT];
      const transientFields = state[action.payload.formName]?.[TRANSIENT_FIELDS];
      state[action.payload.formName] = action.payload.values;
      if (isTransient) {
        state[action.payload.formName]![TRANSIENT] = true;
      }
      if (transientFields) {
        state[action.payload.formName]![TRANSIENT_FIELDS] = transientFields;
      }
    },
    clearForm(state, action: PayloadAction<string>) {
      delete state[action.payload];
    },
    toggleTransient(state, action: PayloadAction<{ formName: string; transient: boolean }>) {
      state[action.payload.formName] = state[action.payload.formName] ?? {};
      state[action.payload.formName]![TRANSIENT] = action.payload.transient;
    },
    setTransientFields(state, action: PayloadAction<{ formName: string; fields: string[] }>) {
      state[action.payload.formName] = state[action.payload.formName] ?? {};
      state[action.payload.formName]![TRANSIENT_FIELDS] = action.payload.fields;
    },
    clearAllForms() {
      return initialState;
    },
  },
});

export const { setFormValues, clearForm, clearAllForms, toggleTransient, setTransientFields } =
  rhfFormsSlice.actions;
export default rhfFormsSlice.reducer;
